<div class="full-view flex-centered boxWrapper">
  <img class="cloud normal" src="./assets/img/wolke_4.png" alt="" />
  <img class="cloud flipped" src="./assets/img/wolke_4.png" alt="" />

  <div class="centered-box">
    <h2>Wartungsarbeiten</h2>
    <p></p>
    <p></p>
    <div class="text">
      <h3>Hey! Um Deine Erfahrung zu verbessern, führen wir gerade Wartungsarbeiten durch.</h3>
      <p></p>
      <h4>Keine Sorge, wir sind bald wieder online! Danke für Dein Verständnis und bis gleich.</h4>
    </div>
    <img class="logo" alt="Logos der Markant Start-up Arena" src="./assets/svg/Voila_Logo_RGB_2022_positiv.svg" />
  </div>
</div>
